import { DataApiInputParams } from 'src/types/api';
import { Builder, appendFormData, getHeaders, getQueryString } from './utils';

export default (builder: Builder) => {
  return {
    fetchModels: builder.query({
      async queryFn(arg: DataApiInputParams, _, __, fetchWithBQ) {
        const params = arg.params?.id
          ? `/${arg.params.id}?${getQueryString(arg.params)}`
          : `?${getQueryString(arg.params)}`;
        const url = `expert-advisor/models${params}`;
        return fetchWithBQ({
          url,
          ...getHeaders(url)
        });
      },
      providesTags: ['Models']
    }),

    createModel: builder.mutation({
      async queryFn(arg: DataApiInputParams, _, __, fetchWithBQ) {
        const formData = appendFormData(arg.params);
        const url = 'expert-advisor/models';

        return fetchWithBQ({
          url,
          method: 'POST',
          body: formData,
          ...getHeaders(url, formData)
        });
      }
    }),

    updateModel: builder.mutation({
      async queryFn(arg: DataApiInputParams, _, __, fetchWithBQ) {
        const formData = appendFormData(arg.params);
        const url = `expert-advisor/models/${arg.params?.id}`;
        return fetchWithBQ({
          url,
          method: 'PUT',
          body: formData,
          ...getHeaders(url, formData)
        });
      },
      invalidatesTags: ['Models']
    }),
    deprecateModel: builder.mutation({
      async queryFn(arg: DataApiInputParams, _, __, fetchWithBQ) {
        const formData = appendFormData(arg.params);
        const url = `expert-advisor/models`;
        return fetchWithBQ({
          url,
          body: formData,
          method: 'PATCH',
          ...getHeaders(url, formData)
        });
      },
      invalidatesTags: []
    })
  };
};
